import Component from 'inferno-component';
import { connect } from 'inferno-redux';
import debounce from 'debounce';
import { getWords, getWordsOfTheDay, resetSearchResult } from '../redux/words';
import { sanitizeString } from '../utils';

import HomePageDropdownSearch from './HomePageDropdownSearch';

import SearchIcon from '../assets/images/search-icon';

function mapStateToProps(state) {
  return {
    searchResults: state.words.searchResults,
    selectedWord: state.words.selectedWord,
  };
}

function searchResultMsg(resultLength) {
  if (resultLength === 1) return '1 result';
  if (resultLength > 1) return `${resultLength} results`;
  return 'No results found';
}

const initialState = {
  searchTerm: '',
  selectedWordIndex: null,
  isSearching: false,
};

const debounceTime = 125;

class SearchInput extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentWillUnmount() {
    this.setState(initialState);
  }

  fetchSearch = value => {
    const sanitizedSearchTerm = sanitizeString(value);
    const { getWords, resetSearchResult } = this.props;
    if (!value) {
      return resetSearchResult();
    }
    this.setState({ searchTerm: sanitizedSearchTerm, isSearching: true });
    return getWords(sanitizedSearchTerm).then(searchResults => {
      this.setState({
        searchResults,
        isSearching: false,
      });
    });
  };

  updateSearch = debounce(e => {
    const { value } = e.target;
    this.fetchSearch(value);
  }, debounceTime);

  updateSearchOnSubmit = e => {
    e.preventDefault();
    // App does nothing if nothing is typed in input and user
    // hits the search button, action described in issue #249
    if (!this.props.searchResults.length) {
      return false;
    }
    const { selectedWordIndex } = this.state;
    const wordIndex = selectedWordIndex || 0;

    return this.context.router.push(
      `/definition/${this.props.searchResults[wordIndex].id}`
    );
  };

  handleArrowKey = e => {
    const { selectedWordIndex } = this.state;
    const { keyCode } = e;
    let updatedIndex = null;
    // Up
    if (keyCode === 38) {
      if (selectedWordIndex !== 0) {
        updatedIndex = selectedWordIndex != null ? selectedWordIndex - 1 : 0;
      }
      return this.setState({ selectedWordIndex: updatedIndex });
    }
    // Down
    if (keyCode === 40) {
      if (selectedWordIndex !== this.props.searchResults.length - 1) {
        updatedIndex = selectedWordIndex != null ? selectedWordIndex + 1 : 0;
      } else {
        updatedIndex = this.props.searchResults.length - 1;
      }
      return this.setState({ selectedWordIndex: updatedIndex });
    }
  };

  render() {
    const { searchClassName, searchResults, selectedWord } = this.props;
    const { searchTerm, selectedWordIndex, isSearching } = this.state;
    return (
      <div className={`${searchClassName}-dropdown-search--container`}>
        {searchClassName === 'definition-preview' && <h4>Search Term</h4>}
        <form className="search-form" onsubmit={this.updateSearchOnSubmit}>
          <input
            autocomplete="off"
            autofocus={true}
            id="search-input-field"
            name="search-input-field"
            onKeyUp={this.updateSearch}
            onKeyDown={this.handleArrowKey}
            placeholder="Search for a Hawaiian word"
            defaultValue={selectedWord.word}
            type="text"
          />
          <button type="submit" id="search-button" disabled={isSearching}>
            {/*<SearchIcon /> */}
          </button>
        </form>

        <div className={`${searchClassName}-dropdown-search--autocomplete`}>
          {searchClassName === 'home-page' &&
            searchResults.map((searchResult, i) => {
              const selectedClass = selectedWordIndex === i ? 'selected' : '';
              return (
                <HomePageDropdownSearch
                  searchResult={searchResult}
                  selectedClass={selectedClass}
                />
              );
            })}

          {searchClassName === 'home-page' &&
            searchTerm.length > 1 &&
            searchResults.length === 0 && (
              <div className="home-page-dropdown-search--item">
                No results found
              </div>
            )}

          {searchClassName === 'header-nav' && (
            <div searchClassName="header-nav-dropdown-search--autocomplete--list">
              <ul>
                {searchResults.map((word, i) => {
                  const selectedClass =
                    selectedWordIndex === i ? 'selected' : '';
                  return (
                    <li className="header-nav__link">
                      <a
                        href={`/definition/${word.id}`}
                        className={`link ${selectedClass}`}
                      >
                        {word.word}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          {searchClassName === 'header-nav' &&
            searchTerm.length > 1 &&
            searchResults.length === 0 && (
              <li className="header-nav__link">No results found </li>
            )}
        </div>

        {searchClassName === 'definition-preview' && (
          <div>
            {searchTerm.length > 1 && (
              <h4>{searchResultMsg(searchResults.length)}</h4>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, {
  getWords,
  getWordsOfTheDay,
  resetSearchResult,
})(SearchInput);



// WEBPACK FOOTER //
// ./src/components/SearchInput.js